export default __webpack_public_path__ + "static/media/calling.838b1c87.gif";